<div class="thp-form-container">
  <div class="eeoc-header">
    {{"talent-happy-path.eeoc-page.title" | translate}}
  </div>
  <div class="spinner-container" *ngIf="isInitialLoad">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
  <form [formGroup]="talentEeocForm" *ngIf="!isInitialLoad">
    <div class="field-group thp-form top-div">
      <label class="field-label">{{"talent-happy-path.eeoc-page.gender" | translate}}</label>
      <mat-radio-group aria-labelledby="gender-radio-group-label" class="gender-radio-group" formControlName="gender">
        <mat-radio-button *ngFor="let gender of genders" [value]="gender.id">
          {{ gender.description }}
        </mat-radio-button>
      </mat-radio-group>
      <mat-form-field style="width: 100%" class="gender-other-input" *ngIf="talentEeocForm.get('gender').value === GENDER_OTHER_ID">
        <mat-label>{{"talent-happy-path.radio.other-option" | translate}}</mat-label>
        <input matInput type="text" formControlName="customGender">
      </mat-form-field>
    </div>

    <div class="field-group thp-form">
      <label class="field-label">{{"talent-happy-path.eeoc-page.pronouns" | translate}}</label>
      <mat-radio-group aria-labelledby="pronouns-radio-group-label" class="pronouns-radio-group" formControlName="pronouns">
        <mat-radio-button *ngFor="let pronoun of pronouns" [value]="pronoun.id">
          {{ pronoun.description }}
        </mat-radio-button>
      </mat-radio-group>
      <mat-form-field style="width: 100%" class="pronouns-other-input" *ngIf="talentEeocForm.get('pronouns').value === PRONOUNS_OTHER_ID">
        <mat-label>{{"talent-happy-path.radio.other-option" | translate}}</mat-label>
        <input matInput type="text" formControlName="customPronoun">
      </mat-form-field>
    </div>

    <div class="field-group thp-form">
      <label class="field-label">{{"talent-happy-path.eeoc-page.lgbtq" | translate}}</label>
      <mat-form-field style="width: 100%" class="custom-select-field">
        <mat-label>{{"talent-happy-path.select-list.please-select-text" | translate}}</mat-label>
        <mat-select formControlName="lgbtqIdentification" class="lgbtq-input">
          <mat-option *ngFor="let option of selectYesNoOptions" [value]="option.id">{{option.description}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field-group thp-form">
      <label class="field-label">{{"talent-happy-path.eeoc-page.ethnicity" | translate}}</label>
      <mat-radio-group aria-labelledby="ethnicity-radio-group-label" class="ethnicity-radio-group" formControlName="ethnicity">
        <mat-radio-button *ngFor="let ethnicity of ethnicityList" [value]="ethnicity.id">
          {{ ethnicity.description }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="field-group thp-form">
      <label class="field-label">{{"talent-happy-path.eeoc-page.disability" | translate}}</label>
      <mat-form-field style="width: 100%" class="custom-select-field">
        <mat-label>{{"talent-happy-path.select-list.please-select-text" | translate}}</mat-label>
        <mat-select formControlName="disabilityIdentification" class="disability-input">
          <mat-option *ngFor="let option of selectYesNoOptions" [value]="option.id">{{option.description}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field-group thp-form">
      <label class="field-label">{{"talent-happy-path.eeoc-page.age-group" | translate}}</label>
      <mat-form-field style="width: 100%" class="custom-select-field">
        <mat-label>{{"talent-happy-path.select-list.please-select-text" | translate}}</mat-label>
        <mat-select formControlName="ageGroup" class="age-group-input">
          <mat-option *ngFor="let ageGroup of ageGroupList" [value]="ageGroup.id">
            {{ageGroup.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field-group thp-form" *ngIf="homeMarketCountryId == countries.USA">
      <label class="field-label">{{"talent-happy-path.eeoc-page.veteran" | translate}}</label>
      <mat-form-field style="width: 100%" class="custom-select-field">
        <mat-label>{{"talent-happy-path.select-list.please-select-text" | translate}}</mat-label>
        <mat-select formControlName="veteranIdentification" class="veteran-input">
          <mat-option *ngFor="let option of selectYesNoOptions" [value]="option.id">{{option.description}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field-group thp-form">
      <label class="field-label">{{"talent-happy-path.eeoc-page.neurodivergent" | translate}}</label>
      <mat-form-field style="width: 100%" class="custom-select-field">
        <mat-label>{{"talent-happy-path.select-list.please-select-text" | translate}}</mat-label>
        <mat-select formControlName="neurodivergentIdentification" class="neurodivergent-input">
          <mat-option *ngFor="let option of selectYesNoOptions" [value]="option.id">{{option.description}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

  </form>

  <div class="navigation-buttons">
    <button *ngIf="!isFromGather()" mat-stroked-button color="primary" class="back-btn" (click)="goToEmploymentAuthorization()"><mat-icon>arrow_back</mat-icon> {{"talent-happy-path.buttons.back" | translate}}</button>
    <button mat-flat-button [ngClass]="isFromGather() ? 'next-button-gather' : 'next-btn'" (click)="finishTalentProfile()"><mat-icon>check</mat-icon>{{"talent-happy-path.buttons.finish" | translate}}</button>
  </div>
  <div class="button-container">
    <button mat-button class="later-button" (click)="isModalVisible = true" *ngIf="!fromNotAFit">{{"talent-happy-path.buttons.do-later" | translate}}</button>
    <app-confirmation-modal
      [isVisible]="isModalVisible"
      (isVisibleChange)="isModalVisible = $event"
      header="{{'talent-happy-path.talent-profile.later-modal.header' | translate}}"
      description="{{'talent-happy-path.talent-profile.later-modal.description' | translate}}"
      (cancel)="isModalVisible = false"
      (confirm)="doThisLater(); isModalVisible = false">
    </app-confirmation-modal>
  </div>
</div>
